module.exports = __webpack_public_path__ + "static/tiger-boards-950e5313a41eb2938130385649b5cef0.png";